
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcastit/opas",
      function () {
        return require("private-next-pages/podcastit/opas.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcastit/opas"])
      });
    }
  